import { scope } from '#components/generics/js/selectors/scope.js'
import * as generics from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../../styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const icon = one(`.${utilities.elements.icon}`, button)
    const galleryCameras = one(`.${elements.meet_gallery_cameras}`, button.closest(`.${elements.meet_gallery}`))
    const { show, hide } = scope(button)

    icon.classList.toggle(generics.modifiers.animated.rotate_180)
    galleryCameras.classList.toggle(utilities.modifiers.display.none)

    const text = one('span', button)
    if (galleryCameras.classList.contains(utilities.modifiers.display.none)) {
      text.textContent = show
    } else {
      text.textContent = hide
    }
  }
})

export default button => {
  onClick.listen(button)
}
